var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-grid-composite"},[(_vm.componentPath)?_c('AsyncComponent',_vm._g(_vm._b({attrs:{"component-path":_vm.componentPath}},'AsyncComponent',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }